// extracted by mini-css-extract-plugin
export default {"dropzone":"UploadFile_dropzone__vx1+-","reject":"UploadFile_reject__Rdo+E","accept":"UploadFile_accept__PlN9N","browse-button":"UploadFile_browse-button__ypWHq"};